<template>
  <div class="m-b-20">
    <h4>Professional Indemnity Insurance</h4>
    <div class="radio">
      <label>
        <input
          v-model="form.hasInsurance"
          type="radio"
          name="has_insurance"
          data-test="worker-has-insurance"
          :value="true"
          :checked="form.hasInsurance === true"
        />
        I have Professional Indemnity insurance
        <i class="input-helper"></i>
      </label>
    </div>
    <div class="radio">
      <label>
        <input
          v-model="form.hasInsurance"
          type="radio"
          name="has_insurance"
          data-test="worker-does-not-have-insurance"
          :value="false"
          :checked="form.hasInsurance === false"
        />
        I do not have Professional Indemnity insurance
        <i class="input-helper"></i>
      </label>
    </div>
    <div v-if="!completed" class="radio">
      <label>
        <input
          v-model="form.hasInsurance"
          type="radio"
          name="has_insurance"
          data-test="worker-insurance-not-answered"
          :value="null"
          :checked="form.hasInsurance === null"
        />
        No option selected yet
        <i class="input-helper"></i>
      </label>
    </div>

    <div v-if="form.hasInsurance" class="bgm-lightgray p-20 m-b-20 rounded">
      <p class="c-black">
        If you have a Professional Indemnity insurance, please list your
        <strong>policy limit</strong>
        and
        <strong>upload</strong>
        the policy certificate as proof.
        <br />
        <span class="small c-gray">Without proof we will regard you as not having insurance.</span>
      </p>
      <div class="row">
        <div class="col-sm-6">
          <PickerFileFilebank
            class=""
            :pre-selected-files="form.proofOfInsuranceFiles"
            :use-input-field="true"
            input-name="proof_of_insurance_file_ids[]"
            :default-tags="defaultTags"
          ></PickerFileFilebank>
        </div>
        <div class="col-sm-4">
          <label>Policy limit</label>
          <br />
          <div class="input-group">
            <span class="input-group-addon">£</span>
            <input
              v-model.number="form.insurancePolicyLimit"
              type="number"
              name="insurance_policy_limit"
              min="1"
              max="99999999"
              class="form-control text-right"
            />
            <span class="input-group-addon">.00</span>
          </div>
        </div>
      </div>
      <p class="m-t-20 m-b-0 small">
        By uploading a document here, I confirm that the attached files demonstrate legal proof of
        insurance.
      </p>
    </div>
  </div>

  <div class="form-group">
    <div class="col-md-6 col-md-offset-3 text-center">
      <SubmitButton data-test="insurance-information-save-button" :text="$t('Save')" :disabled="!canSave" auto-submit></SubmitButton>
    </div>
  </div>
</template>

<script>
import PickerFileFilebank from '@/components/PickerFileFilebank.vue'
import SubmitButton from '@/components/SubmitButton.vue'

export default {
  name: 'Ir35FreelancerForm',
  components: {
    PickerFileFilebank,
    SubmitButton,
  },
  props: {
    hasInsurance: {
      type: Boolean,
    },
    insurancePolicyLimit: {
      type: Number,
      default: 0,
    },
    proofOfInsuranceFiles: {
      type: Array,
      default: [],
    },
    completed: {
      type: Boolean,
    },
  },
  data() {
    return {
      form: {
        hasInsurance: this.completed ? this.hasInsurance : null,
        insurancePolicyLimit: this.insurancePolicyLimit,
        proofOfInsuranceFiles: this.proofOfInsuranceFiles || [],
      },
    }
  },
  computed: {
    canSave() {
      return this.form.hasInsurance !== null
    },
    defaultTags() {
      return [this.$t('Insurance proof')]
    },
  },
}
</script>

<style scoped></style>
